module.exports = __webpack_public_path__ + "img/formation-portal-green.6dfa6ee0.svg";